module.exports = __webpack_public_path__ + "static/media/target.55b19a3a.svg";